import { useCallback, useState } from "react";

// Custom hook for drag and drop functionality
export const useDragAndDrop = (onFilesDropped: (files: FileList) => void) => {
  const [dragActive, setDragActive] = useState(false);

  const handleDrag = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  }, []);

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setDragActive(false);
      const files = Array.from(e.dataTransfer.files);
      const fileList = new DataTransfer();
      files.forEach((file) => fileList.items.add(file));
      onFilesDropped(fileList.files);
    },
    [onFilesDropped]
  );

  return { dragActive, handleDrag, handleDrop };
};
